<template>
    <div id="about" class="text">
        <div class="heading">
            About me
        </div>
        <br/>
        <p>
            Hey there, glad to know that you are curious about me. You can call me <b>Bhuvan</b> [ boo . won ]</p>
            <p>I'm from the city Erode in India and I currently live in Atlanta, US.
            A creator by heart, I love to see things come to life.
        </p>
        <br/>
        <p>
            I am a senior software engineer at Google. I've worked at VMware and EA Games earlier. My expertise is in android, mobile and creative applications, software architecture and engineering.</p>
            <p>I did my masters in computer science at  <a href="https://en.wikipedia.org/wiki/Georgia_Tech" target="_blank" class="a-link">Georgia Tech</a> and my undergrad was at <a href="https://en.wikipedia.org/wiki/College_of_Engineering,_Guindy" target="_blank" class="a-link">College of Engineering, Guindy</a>.
        </p>
        <br/>
        <p>
            During my leisure, I play tennis and board games. Big Age of Empires II fan.</p>
            <p>I love art, colors and paintings. I dabble with graphic design now and then!</p>
            <p>Of late you can find me at the courts playing or practicing tennis.
        </p>
        <br/>
        <p>
            I encountered the following lines by Robert Frost during my school days and it has stuck with me ever since.
        </p>
        <div style="padding:24px;font-style:italic">
            The woods are lovely, dark and deep,
            <p>But I have promises to keep,</p>
            <p>And miles to go before I sleep,</p>
            <p>And miles to go before I sleep.</p>
        </div>
        <br/>
        <p>
            If you are interested further, you can reach me at <b>bhuvanesh . bleu @ gmail . com</b>.
        </p>
    </div>
</template>

<script>
export default {
    name: 'About'
}
</script>

<style scoped>
#about {
    max-width: 800px;
}
.text{
    font-size: 16px;
}

.a-link {
    color: var(--heading-color);
    text-decoration: none;
    font-weight: normal;
}
.a-link:hover {
    text-decoration: underline;
}
</style>